/**
 * Gallery slider script
 */
class Orion_GalleryMediaSlider {
  constructor (wrapper) {
    this.sliderWrapper = wrapper;  
    this.initState();
    this.initEvents();
  }

  initState() {
    this.prevBtn = this.sliderWrapper.find('.prev');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.list = this.sliderWrapper.find('.gallery-media-slider-list');
    this.items = this.list.find('.gallery-media-slider-item');
    this.currentItem = 0;
    this.animationInProgress = false;
  }

  initEvents() {
    if (this.sliderWrapper.length) {
      this.initUI();
    }
  }

  initUI () {        
    this.swipeEffect = new Hammer(this.sliderWrapper[0]);

    this.prevBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem--;
      this.animationInProgress = true;

      if (this.currentItem === 0) {
        this.prevBtn.addClass('is-hidden');
      }

      this.list.css('margin-left', (-100 * this.currentItem) + "%");
      this.nextBtn.removeClass('is-hidden');

      setTimeout(() => {
          this.animationInProgress = false;
      }, 250);
    });

    this.nextBtn.on('click', e => {
      e.preventDefault();

      if (this.animationInProgress) {
        return;
      }

      this.currentItem++;
      this.animationInProgress = true;

      if (this.currentItem === (this.items.length - 1)) {
        this.nextBtn.addClass('is-hidden');
      }

      if (this.currentItem >= this.items.length) {
        this.currentItem = (this.items.length - 1);
      }

      this.list.css('margin-left', (-100 * this.currentItem) + "%");
      this.prevBtn.removeClass('is-hidden');

      setTimeout(() => {
        this.animationInProgress = false;
      }, 250);
    });

    this.swipeEffect.on('swipe', ev => {
      if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
        if (this.currentItem < this.items.length - this.itemsPerPage) {
          this.currentItem++;
        } else {
          this.currentItem = 0;
        }

        this.next.eq(this.currentItem).trigger('click');
      }

      if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
        if (this.currentItem > 0) {
          this.currentItem--;
        } else {
          this.currentItem = this.items.length - this.itemsPerPage;
        }

        this.prev.eq(this.currentItem).trigger('click');
      }
    });
  }
}
